import { ReactNode } from 'react';
import { Routes, Route } from 'react-router';

import Obras from 'Pages/Obras';
import Disciplinas from 'Pages/Disciplinas';
import ListagemArquivos from 'Pages/ListagemArquivos';
import Usuarios from 'Pages/GerenciarUsuarios/Usuarios';
import PapeisPermissoes from 'Pages/GerenciarUsuarios/PapeisPermissoes';
import Nomenclatura from 'Pages/Config/Nomenclatura';
import Plotagens from 'Pages/Plotagens';
import PlotagemArquivos from 'Pages/Plotagens/PlotagemArquivos/PlotagemArquivos';
import PlotagemAReceber from 'Pages/Plotagens/PlotagemAReceber/PlotagemAReceber';
import Extensoes from 'Pages/Config/Extensoes';
import Armazenamento from 'Pages/Config/Armazenamento';
import MinhaConta from 'Pages/MinhaConta';
import Sobre from 'Pages/Sobre';
import Notification from 'Pages/Notification';
import Faturamento from 'Pages/Faturamento';
import TrocarPlanos from 'Pages/Faturamento/TrocarPlanos';
import Planos from 'Pages/Adm/Planos';
import Tenants from 'Pages/Adm/Tenants';
import Stages from 'Pages/Adm/Stages';
import DadosFaturamento from 'Pages/Faturamento/DadosFaturamento';
import Downgrade from 'Pages/Faturamento/Downgrade';
import FederatedViewer from 'Pages/FederatedViewer';
import Activities from 'Pages/Activities';
import Personalization from 'Pages/Personalization';
import Panels from 'Pages/Panels';
import EditObra from 'Pages/EditObra';

import ChangeContext from 'Components/ShellHost/ChangeContext';
import { IconName } from 'Components/UI';

export interface IRoute {
  path: string;
  component?: ReactNode;
  title?: string;
  i18nKey?: string;
  redirect?: string;
  icon?: IconName;
  children?: IRoute[];
  isChange?: boolean;
  isPremium?: boolean;
  isPermissionUser?: number[];
  existNotification?: boolean;
}

const allUsers = [1, 3, 4, 5, 6, 7];

export const routes: IRoute[] = [
         {
           path: 'obras',
           title: 'Obras',
           i18nKey: 'sidebar:menu.obras',
           redirect: '/obras',
           icon: 'menuObras',
           isChange: true,
           component: <Obras />,
           isPermissionUser: allUsers,
           existNotification: true,
           children: [
             {
               path: 'detail/:constructionSiteId',
               component: <Disciplinas />,
             },
             {
               path: 'detail/:constructionSiteId/:isNewConstructionSite',
               component: <Disciplinas />,
             },
             {
               path: 'filelist/:constructionSiteId/:folderId',
               component: <ListagemArquivos />,
             },
             {
               path: 'plotagens/:constructionSiteId',
               component: <Plotagens />,
               isPremium: true,
               isPermissionUser: allUsers,
             },
             {
               path:
                 'plotagens/filelist/:constructionSiteId/:ConstructionSiteDisciplineFk',
               component: <PlotagemArquivos />,
             },
             {
               path:
                 'plotagens/filelist/receber/:constructionSiteId/:ConstructionSiteDisciplineFk',
               component: <PlotagemAReceber />,
             },
             {
               path: 'viewer/detail/:constructionSiteId',
               component: <FederatedViewer />,
             },
             {
               path: 'activities/detail/:constructionSiteId',
               component: <Activities />,
             },
             {
               path: 'panels/:constructionSiteId/:panelId',
               component: <Panels />,
             },
             {
               path: 'edit/:constructionSiteId/:editId',
               component: <EditObra />,
             },
           ],
         },
         {
           path: 'gerenciar-usuarios',
           title: 'Gerenciar usuários',
           i18nKey: 'sidebar:menu.gerenciarUsuarios',
           redirect: '/gerenciar-usuarios/usuarios',
           icon: 'menuGerenciarUsuario',
           component: <Usuarios />,
           isPermissionUser: [1, 3, 7],
           isPremium: true,
           children: [
             {
               path: 'usuarios',
               title: 'Usuários da maleta',
               i18nKey: 'sidebar:menu.usuariosDaMaleta',
               redirect: '/gerenciar-usuarios/usuarios',
               isPremium: true,
               component: <Usuarios />,
             },
             {
               path: 'papeis',
               title: 'Papéis e permissões',
               i18nKey: 'sidebar:menu.papeisPermissoes',
               redirect: '/gerenciar-usuarios/papeis',
               isPremium: true,
               component: <PapeisPermissoes />,
             },
           ],
         },
         {
           path: 'config',
           title: 'Configurar serviço',
           i18nKey: 'sidebar:menu.configurarServico',
           redirect: '/config/nomenclatura',
           icon: 'menuConfiguracoes',
           component: <Nomenclatura />,
           isPermissionUser: [1, 7],
           children: [
             {
               path: 'nomenclatura',
               title: 'Nomenclatura',
               i18nKey: 'sidebar:menu.nomenclatura',
               redirect: '/config/nomenclatura',
               component: <Nomenclatura />,
             },
             {
               path: 'extensoes',
               title: 'Extensões',
               i18nKey: 'sidebar:menu.extensoes',
               redirect: '/config/extensoes',
               component: <Extensoes />,
             },
             {
               path: 'armazenamento',
               title: 'Armazenamento',
               i18nKey: 'sidebar:menu.armazenamento',
               redirect: '/config/armazenamento',
               component: <Armazenamento />,
             },
             {
               path: 'personalization',
               title: 'Personalização',
               i18nKey: 'sidebar:menu.personalization',
               redirect: '/config/personalization',
               component: <Personalization />,
               isPermissionUser: [1],
             },
           ],
         },
         {
           path: 'construtora/:tenantId',
           component: <ChangeContext />,
         },
         {
           path: 'conta',
           component: <MinhaConta />,
         },
         {
           path: 'sobre',
           component: <Sobre />,
         },
         {
           path: 'notification',
           component: <Notification />,
         },
         {
           path: 'faturamento',
           component: <Faturamento />,
           children: [
             {
               path: 'planos',
               component: <TrocarPlanos />,
             },
             {
               path: 'planos/dadosfaturamento',
               component: <DadosFaturamento />,
             },
             {
               path: 'planos/dadosfaturamento/downgrade',
               component: <Downgrade />,
             },
           ],
         },
         {
           path: 'adm',
           component: <Planos />,
           children: [
             {
               path: 'planos',
               component: <Planos />,
             },
             {
               path: 'tenants',
               component: <Tenants />,
             },
             {
               path: 'stages',
               component: <Stages />,
             },
           ],
         },
       ];

export const MainSwitch = () => (
  <Routes>
    <Route path='/' />
    <Route index element={<Obras />} />
    <Route path='*' element={<Obras />} />
    {createRoute(routes)?.reverse()}
  </Routes>
);

const createRoute = (routeList?: IRoute[]) => {
  return routeList?.map((props) => {
    if (props.children) {
      return (
        <Route key={`route-menu-${props.path}`} path={props.path}>
          <Route index element={props.component} />
          {props.children && createRoute(props.children)}
        </Route>
      );
    }

    return (
      <Route
        key={`route-menu-${props.path}`}
        path={props.path}
        element={props.component}
      />
    );
  });
};
